import React from "react";
import OfficeHours from "./OfficeHours";
import FederalReligious from "../federalHolidays/FederalReligious";

const OfficeHoursWrapper = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div>
        <OfficeHours />
      </div>
      <div>
        <FederalReligious />
      </div>
    </div>
  );
};

export default OfficeHoursWrapper;
